// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"25":"8ae52bb1af9312ab","710":"9e2c6e7f36dd637f"}[chunkId] + ".js";
};